import { InteractionStepType } from '@scale/shared/types/chat';

export function allowDownstreamTemplating(type: InteractionStepType) {
  return [
    InteractionStepType.PromptInput,
    InteractionStepType.ModelResponseSelector,
    InteractionStepType.MultiTurnContinue,
  ].includes(type);
}

// For benchmarks
// We only show the answer key editing for certain types of steps
export function displayAnswerKeyEditing(type: InteractionStepType) {
  return [
    InteractionStepType.ModelResponseSelector,
    InteractionStepType.TextCollection,
    InteractionStepType.TextCollectionPerResponse,
    InteractionStepType.ProcessSupervision,
    InteractionStepType.ModelResponseRanking,
    InteractionStepType.QualityMeasurement,
  ].includes(type);
}
